import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNServiceCode } from './cnservicecode';
import { CNServiceCodeINAMIValue } from './cnservicecodeinamivalue';
import { SNItemFactory } from './snitemfactory';

@RegisterItem()
export class CNServiceCodeINAMI extends CNServiceCode {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNServiceCode.CNServiceCodeINAMI';
    }

    public clone(): any {
        return new CNServiceCodeINAMI();
    }


    /**
     * JSON
     */

     public fromJson(json: any, emitLoaded?: boolean): void {
        super.fromJson(json, emitLoaded);
        if (typeof json.values !== 'undefined' && Array.isArray(json.values) && json.values.length !== 0) {
            this.values = [];
            const factory = new SNItemFactory();
            json.values.forEach(valuejson => {
                this.values.push(factory.itemFromJson(valuejson));
            });
        }
        this.itemchecksum = this.checksum;
    }
}
